module.exports = __webpack_public_path__ + "static/media/windy.0a4e0ddf.webp";